// Singleton holding the currently-active organization id.
//
// Why a singleton: API helpers are plain functions, not React components, so
// they can't read context directly. AuthProvider keeps this in sync with the
// user's selected org; API helpers read from it when they need to scope
// queries or set org_id on inserts.
//
// localStorage persists across reloads. The AuthProvider initialises this on
// mount and keeps it synced.

const STORAGE_KEY = "prado_pulse.active_org_id";

let activeOrgId: string | null =
  typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;

const listeners = new Set<(orgId: string | null) => void>();

export function getActiveOrgId(): string | null {
  return activeOrgId;
}

export function setActiveOrgId(orgId: string | null): void {
  if (orgId === activeOrgId) return;
  activeOrgId = orgId;
  if (typeof window !== "undefined") {
    if (orgId) localStorage.setItem(STORAGE_KEY, orgId);
    else localStorage.removeItem(STORAGE_KEY);
  }
  listeners.forEach((fn) => fn(orgId));
}

export function subscribeActiveOrg(fn: (orgId: string | null) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
